import React from "react";
import { Typography, Breadcrumbs, Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import { useTranslation } from "../../langs/useTranslation";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { HomeOutlined } from "@material-ui/icons";

export const BreadCrumbs = props => {
  const {
    deviceId,
    deviceOsType,
    pageName,
    showDeviceList,
    noTranslate,
    alarm,
    schedule,
    cms,
    deviceNaming
  } = props;
  const { t } = useTranslation("common");

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Link color="inherit" to="/dashboard">
        <HomeOutlined />
        Home
      </Link>
      {showDeviceList && (
        <Link color="inherit" to="/groups/groups-devices">
          {t("breadcrumb.deviceMonitoring")}
        </Link>
      )}
      {deviceId && deviceOsType && (
        <Link
          color="inherit"
          to={`/device-list/device-detail/${deviceId}/${deviceOsType}`}
        >
          {t("breadcrumb.deviceDetail")}
        </Link>
      )}
      {alarm && (
        <Link color="inherit" to={"/alarm/templates"}>
          {t({ defaultMessage: "报警管理" })}
        </Link>
      )}
      {schedule && (
        <Link color="inherit" to={"/schedule/templates"}>
          {t({ defaultMessage: "排程管理" })}
        </Link>
      )}
      {cms && (
        <Link color="inherit" to={"/CMS/template/list"}>
          {t({ defaultMessage: "内容管理" })}
        </Link>
      )}
      {deviceNaming && (
        <Link color="inherit" to={"/setting/device-naming/list"}>
          {t({ defaultMessage: "设备命名规则" })}
        </Link>
      )}
      <Typography color="textPrimary">
        {noTranslate ? pageName || "-" : t(`breadcrumb.${pageName}`)}
      </Typography>
    </Breadcrumbs>
  );
};

export const NestedBreadCrumbs = React.memo(props => {
  const { linkArray, onClick } = props;

  const handleLinkClick = (e, i) => {
    onClick(e, i);
  };

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Link color="inherit" to="/dashboard">
        Home
      </Link>
      {linkArray &&
        linkArray.map((o, i) => {
          let ifLastItemAndNotMainPage =
            i === linkArray.length - 1 && o.parent_id;
          return (
            <Box
              key={i}
              id={o.parent_id}
              color="inherit"
              className={!ifLastItemAndNotMainPage ? "pointer" : ""}
              onClick={
                !ifLastItemAndNotMainPage ? e => handleLinkClick(e, i) : null
              }
            >
              {o.name}
            </Box>
          );
        })}
    </Breadcrumbs>
  );
});
